import {
  amazonCheckout,
  amazonHome,
  amazonOrders,
  amazonTracking,
  calcCover,
  calcDark,
  calcLight,
  landingHero,
  landingSection,
  rockPaper,
  rockPaperCover,
  youtubeClone,
  cartBlogLg,
  cartBlogSm,
  cartCartLg,
  cartRegisterSm,
  cartSettings,
  amazonTesting,
  screwCover,
  screwCards1,
  screwCards2,
  screwContact,
  screwScore,
} from '../assets/projects.js';

const a3detScrew = {
  title: 'A3det-Screw Website',
  technologies: ['# VanillaJS', '# HTML', '# CSS'],
  description: [
    <div key="1">
      Front-end website including main functionalities:{' '}
      <span className="highlight-text font-bold">Dynamic</span> Score calculator
      - Cards page - Contact page.
    </div>,
    <div key="2">
      Applied <span className="highlight-text">modern colorful</span> design to
      create an attractive and user-friendly interface, improving overall user
      experience.
    </div>,
    <div key="3">
      Integrated <span className="highlight-text">Microsoft Clarity</span> to
      track user interactions. Gathered insights of 95% performance over 880+
      sessions.
    </div>,
    <div key="4">
      {' '}
      <span className="highlight-text">
        Integrated Google Forms as a Backend API
      </span>{' '}
      : Used Google Forms to handle submissions on the contact page, effectively
      creating a backend solution without additional server-side code.
    </div>,
    <div key="6">
      Used <span className="highlight-text">JavaScript obfuscation</span> to
      secure the code since the website is published publicly.
    </div>,
    <div key="7">
      Applied <span className="highlight-text">Responsive Web Design</span> to
      make it friendly with all devices.
    </div>,
  ],
  coverImg: screwCover,
  images: [screwCards1, screwContact, screwCards2, screwScore],
  actionText: 'See It Live',
  actionLink: 'https://a3det-screw.onrender.com',
};

const reactWebApp = {
  title: 'React Web Application',
  technologies: ['# ReactJS', '# Axios', '# Joi Validation', '# React-Router'],
  description: [
    <div key="1">
      Developed a multi-page web application built using{' '}
      <span className="highlight-text">ReactJS</span>.
    </div>,
    <div key="2">
      Integrated a <span className="highlight-text">RESTful API</span> using a
      local JSON server for fetching and updating product data.
    </div>,
    <div key="3">
      Implemented features in React way such as{' '}
      <span className="highlight-text">adding/removing items</span> from the
      cart and calculating totals dynamically.
    </div>,
    <div key="4">
      Used <span className="highlight-text">React Router</span> for navigation
      across multiple pages and created{' '}
      <span className="highlight-text">ProtectedRoutes</span> for logged users.
    </div>,
    <div key="5">
      Added <span className="highlight-text">Joi validation</span> library for
      Registeration and login forms, ensuring error handling.
    </div>,
    <div key="6">
      Focused on building a clean,{' '}
      <span className="highlight-text">responsive UI</span> in different
      components such as header.
    </div>,
  ],
  coverImg: cartCartLg,
  images: [cartBlogLg, cartCartLg, cartRegisterSm, cartBlogSm, cartSettings],
  actionText: 'See It Live',
  actionLink: 'https://cart-multi-page.web.app',
};

const amazonClone = {
  title: 'Javascript Amazon Clone',
  technologies: ['# VanillaJS', '# Jasmine Testing', '# HTML', '# CSS'],
  description: [
    <div key="0" className="mb-3">
      Large Project built in{' '}
      <span className="highlight-text">
        VanillaJS with{' '}
        <span className="underline font-bold">NO Front-End frameworks</span>.
      </span>
    </div>,
    <div key="1">
      Implemented core functionalities including HomePage, Checkout,{' '}
      <span className="highlight-text">Product Search, Order Tracking</span>,
      and <span className="highlight-text">Choosing Delivery Options</span>.
    </div>,
    <div key="2">
      Integration with backend fetching products and sending post requests for
      orders.
    </div>,
    <div key="3">
      Structured the project using{' '}
      <span className="highlight-text">Object-Oriented Programming (OOP)</span>{' '}
      Principles in Javascript. the project is structured using classes,
      inheritance, and polymorphism.
    </div>,
    <div key="4">
      Applied <span className="highlight-text">MVC architecture</span> in
      developing the website.
    </div>,
    <div key="5">
      Created test suites using the{' '}
      <span className="highlight-text">Jasmine framework</span> for both unit
      and integration testing.
    </div>,
    <div key="6">
      Learned with full knowledge Callbacks, promises, and async/await
    </div>,
    <div key="7">
      Learned <span className="highlight-text">Error Handling</span> in
      Javascript
    </div>,
  ],
  coverImg: amazonHome,
  images: [
    amazonCheckout,
    amazonHome,
    amazonOrders,
    amazonTracking,
    amazonTesting,
  ],
  actionText: 'Open It Live',
  actionLink: 'https://clone-34386.web.app',
};



export default [
  a3detScrew,
  // reactWebApp,
  amazonClone,
  {
    title: 'Simple Landing Page',
    technologies: ['# TailwindCSS'],
    description: [
      <div key="1">
        Designed a simple modern{' '}
        <span className="highlight-text">Landing Page</span> using HTML and
        TailwindCSS.
      </div>,
      <div key="2">
        Ensured <span className="highlight-text">Responsive</span> web design
        for all screens.
      </div>,
    ],
    coverImg: landingHero,
    images: [landingHero, landingSection],
    actionText: 'See It Live',
    actionLink: 'https://abdullahashraff.github.io/landing',
  },
  {
    title: 'YouTube Clone',
    technologies: ['# HTML', '# CSS'],
    description: [
      <div key="1">
        That&apos;s a simple project replicating YouTube Home Page using HTML
        and CSS.
      </div>,
    ],
    coverImg: youtubeClone,
    images: [],
    actionText: 'See It Live',
    actionLink: 'https://abdullahashraff.github.io/youtube',
  },
  {
    title: 'Rock Paper Scissors Game',
    technologies: ['# VanillaJS', '# HTML', '# CSS'],
    description: [
      <div key="1">
        Interactive game with real-time feedback on user and computer choices.
      </div>,
      <div key="2">
        used <span className="highlight-text">Local Storage</span> to save
        user&apos;s score.
      </div>,
      <div key="3">
        Built with VanillaJS with a smooth gameplay{' '}
        <span className="highlight-text">CSS Animations</span>
      </div>,
      <div key="3">
        Applied a <span className="highlight-text">Responsive UI Design</span>{' '}
        compatible with different screens.
      </div>,
    ],
    coverImg: rockPaperCover,
    images: [rockPaper],
    actionText: 'Play It Live',
    actionLink: 'https://abdullahashraff.github.io/rock-paper',
  },
  {
    title: 'Multi-Theme Calculator',
    technologies: ['# VanillaJS', '# HTML', '# CSS'],
    description: [
      <div key="1">
        This is a simple project presenting a functional calculator created
        using VanillaJS.
      </div>,
      <div key="2">
        It is powered by{' '}
        <span className="highlight-text">toggleable dark and light themes</span>{' '}
        for a better user experience.
      </div>,
      <div key="3">
        Performs advanced calculations using{' '}
        <span className="highlight-text">JavaScript’s eval() function</span>,
        supporting parentheses and operator precedence.
      </div>,
      <div key="4">
        Includes a simple user interface with buttons for standard arithmetic
        operations and theme switching.
      </div>,
    ],
    coverImg: calcCover,
    images: [calcDark, calcLight],
    actionText: 'Try It Live',
    actionLink: 'https://abdullahashraff.github.io/calc',
  },
];
